import { React, classNames } from '@digsup/core-ui';
import { WaveLeft } from './assets/WaveLeft';
import { WaveRight } from './assets/WaveRight';
import { LabAsset } from './LabAsset';
import { LabTube } from './LabTube';
import { styles } from './Lab.scss';

const cx = classNames.bind(styles);

export const Lab = () => (
  <div className={cx('l-homepage-hero-lab')} id="hero-lab">
    <WaveLeft className="l-homepage-hero-lab__wave-left" />
    <WaveRight className="l-homepage-hero-lab__wave-right" />
    <div className="l-homepage-hero-lab__inner">
      <div className="l-homepage-hero-lab__asset">
        <LabAsset />
      </div>
      <div className="l-homepage-lab__tube">
        <LabTube />
      </div>
    </div>
  </div>
);
